module.exports = __webpack_public_path__ + "bf1b499d6de31cd123b252b621e0a141.pdf";